module.exports = __webpack_public_path__ + "media/images/icare-card-fdd1bc29de264f678a547e6ccb9767d1.png";